const config = {}

// Env
config.environment = 'production'
config.apiVersion = 1
config.noIndex = false

// Company name
config.companyName = 'Toast'

// Trusted hostname
config.trustedHosts = [
  'www.toasttab.com',
  'toasttab.com',
  'prod.nv5.toast.ventures'
]

config.serviceName = 'sites-web'

config.reCaptchaEnterprise = {}
config.reCaptchaEnterprise.siteKey = '6LfD-H8mAAAAAK-gw-dLyIgoh1TpBg2VuSZi5SJA'

// Configuration namespaces
config.server = {}
config.resources = {}
config.datadog = {}
config.sentry = {}
config.owg = {}
config.sift = {}
config.toast = {}
config.responseCache = {}
config.logging = {}

config.toast.clientId = 'encrypted:prod/oauth/sites-web:client_id'
config.toast.clientSecret = 'encrypted:prod/oauth/sites-web:client_secret'

config.gMapsAPIKey = 'AIzaSyDsJlw0WSpry4Kig6-1LfjR0vo89NYZudM'
config.gMapsId = 'b43478dc6347bc0fefa9ebdb'
config.gPlacesAPIKey = 'AIzaSyDx-1bQhTqW3DUEPNMTk-yegz1c9YQdzUs'
config.ldClientId = '59e4bfdd6292ac0ac9174386'
config.ldSdkKey = 'sdk-1251e53d-b792-47b7-b5de-118f8da99497'
config.intercomAppId = 'as3e58xg'
config.amplitudeApiKey = 'beee74d9d5b5b3f679127e4d272881ee'
config.giftCardRecaptchaSiteKey = '6LdI_fcpAAAAANCTIma-FhR0C3EBGvMV-CYuhozK'

// Resources configuration
config.resources.serverQueryTimeoutMs = 10_000
config.resources.clientQueryTimeoutMs = 30_000
config.resources.apiHost =
  typeof window === 'undefined'
    ? 'http://localhost:36867'
    : 'https://ws-api.toasttab.com'
config.resources.wssHost = 'wss://wss.toasttab.com'
config.resources.apiEndpoint = `${config.resources.apiHost}/sites-api/v1/api`
config.resources.mapEndpoint = 'https://ws-api.toasttab.com/sites-api/v1/api'
config.resources.federatedProxyHost = `${
  config.resources.apiHost
}/do-federated-gateway/v1/${
  typeof window === 'undefined' ? 'internal/' : ''
}graphql`
config.resources.webpackDevServer = false
config.resources.publicAssetURL = 'https://d28f3w0x9i80nq.cloudfront.net/'
config.resources.imagePrefix = 'https://d1w7312wesee68.cloudfront.net/'
config.resources.publicAppURL = `${config.resources.publicAssetURL}app`
config.resources.ooAssetURL = null // Production image urls work out of the box, and no hostname substitution is needed
config.resources.tlAssetUrl = 'https://d2s742iet3d3t1.cloudfront.net/'
config.resources.checkoutHost = 'https://www.toasttab.com/'
config.resources.toastLocalHost = 'www.toasttab.com'
config.resources.toastOrderHost = 'order.toasttab.com'
config.resources.toastAppHost = 'toast.app'
config.resources.bookHost = 'book.toasttab.com'
config.resources.schemaHostBlocklist = [config.resources.toastLocalHost]
config.resources.exposeSitemap = true
config.resources.sitemapGenerationBatchSize = 10
config.resources.toastwebBaseUri = 'https://www.toasttab.com/'
config.resources.s3Bucket = 'toast-sites-resources-prod'
config.resources.adyenURL = 'https://*.adyen.com'
config.resources.semiPaymentGatewayURL =
  'https://ws-api.toasttab.com/semi-payments-gateway'
config.resources.googlePayURL = 'https://pay.google.com/'
config.resources.googleURL = 'https://google.com/'
config.resources.spiURL = 'https://payments.toasttab.com/assets/loader.js'
config.resources.bookingScriptUrl =
  'https://toast.app/scripts/widgets/reserve.js'
config.resources.reservationFallbackUrl =
  'https://tables.toasttab.com/restaurants'
// Guest Analytics API endpoint
config.resources.guestAnalyticsApiEndpoint = `${config.resources.apiHost}/guest-analytics-intake/v1/events`
// Overrides the default config to disable Google Pay
config.resources.paymentMethodConfigId = '874631f2-eb32-4287-8c6b-d5c0eb6bbff6'

config.resources.trustedApiHosts = [config.resources.apiHost]

// Server configuration
config.server.protocol = 'https'
config.server.httpPort = 8443
config.server.webpackDevServerProtocol = null
config.server.webpackDevServerPort = 8000
config.server.host = 'ws-api.toasttab.com'
config.server.altHosts = []
config.server.fullHost = config.server.host
config.server.allowableResourceHosts = {}

config.resources.sitesHost = `${config.server.protocol}://${config.server.host}`

config.server.allowableResourceHosts.script = [
  'https://browser.sentry-cdn.com',
  'https://fonts.googleapis.com',
  'https://fonts.gstatic.com',
  'https://maps.googleapis.com',
  'https://*.googletagmanager.com',
  'https://ajax.cloudflare.com',
  'https://www.google.com/recaptcha/',
  'https://www.gstatic.com/recaptcha/',
  'https://cdn.userway.org/',
  'https://api.userway.org/',
  'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/',
  'https://cdn.sift.com/s.js',
  'https://toast.fides-cdn.ethyca.com',
  'https://book.toasttab.com',
  'https://toast.app'
]
config.server.allowableResourceHosts.pixels = [
  'www.toasttab.com',
  'https://www.google-analytics.com',
  'analytics.google.com',
  'www.googleadservices.com',
  '*.doubleclick.net',
  '*.facebook.net',
  '*.hotjar.com',
  'wss://*.hotjar.com',
  'https://www.facebook.com/privacy_sandbox/topics/registration/',
  'https://www.facebook.com/signals/iwl.js',
  'https://payments.toasttab.com',
  'https://payments.sandbox.eng.toasttab.com', // A bug with spi loads the manifest file from sandbox, even in prod
  'https://www.google.com',
  'https://www.googletagmanager.com',
  'https://pagead2.googlesyndication.com',
  'https://google.com'
]
config.server.allowableResourceHosts.connect = [
  'https://www.google.com',
  'https://maps.googleapis.com',
  'https://*.google-analytics.com',
  'https://*.analytics.google.com',
  'https://*.googletagmanager.com',
  'https://graph.facebook.com/',
  'https://www.facebook.com/tr/',
  'https://events.launchdarkly.com',
  'https://app.launchdarkly.com',
  'https://clientstream.launchdarkly.com',
  'https://api2.amplitude.com/2/httpapi',
  'https://cdn.userway.org/',
  'https://api.userway.org/',
  'https://privacy-toast.us.fides.ethyca.com/',
  'https://toast.fides-cdn.ethyca.com',
  'https://book.toasttab.com',
  'https://toast.app',
  'https://s3.amazonaws.com/toast-sites-restricted-prod'
]
config.server.allowableResourceHosts.style = [
  'https://unpkg.com',
  'https://fonts.googleapis.com',
  'https://use.typekit.net',
  'https://p.typekit.net',
  'https://cdn.userway.org/',
  'https://api.userway.org/'
]
config.server.allowableResourceHosts.frameSrc = [
  'https://www.googletagmanager.com',
  'https://cdn.userway.org/',
  'https://business.untappd.com',
  'https://book.toasttab.com',
  'https://toast.app'
]

// Sentry
config.sentry.host = 'o37442.ingest.sentry.io'
config.sentry.dsn = `https://6d67e6de629842998b120b40164bd25b@${config.sentry.host}/6180756`
config.sentry.env = 'production'
config.sentry.cspReportEndpoint = `https://${config.sentry.host}/api/6180756/security/?sentry_key=6d67e6de629842998b120b40164bd25b&sentry_environment=${config.sentry.env}`

// Order with Google Redirects
config.owg.partnerId = '20001125'
config.owg.ooPartnerId = '20003218'
config.owg.conversionHost = 'https://www.google.com/maps/conversion/collect'

// Logging configuration
config.logging.console = false
config.logging.splunk = true
config.logging.request = true
config.logging.level = 'info'

// Toast DataDog RUM config
config.datadog.rum = {
  enabled: true,
  clientToken: 'pub42715a09f9a12b1dd63162ff54b9b2b3',
  applicationId: 'b8973e2d-9c80-4e55-93a3-3c9e994702ea',
  samplingRate: 100,
  sessionReplaySampleRate: 0,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  host: [
    'https://browser-intake-datadoghq.com',
    'www.datadoghq-browser-agent.com'
  ],
  version: `${process.env.toast_service_revision}`
}

config.ethycaPropertyId = 'FDS-HTPGY8'
config.ethycaPropertyIdAds = 'FDS-K2DDSO'
config.sift.beaconKey = '3ae2d35896'

// Cache Control
config.cache = {
  cacheAge: 60, // Intermediate cache control
  browserAge: 120, // Browser cache control
  browserExpiresMinutes: 2 // expiration management
}
config.enableCompression = false

config.responseCache.url =
  'redis://prod-sites-web-cache.glzywl.ng.0001.use1.cache.amazonaws.com'

config.localByToastIOSAppId = 1362180579

// Cluster configuration
config.cluster = {
  enabled: false,
  workers: 2,
  restartDelay: 1000,
  maxRestarts: 2
}

module.exports = config
